(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('updateSimCardCtrl', ['$scope', '$state', 'updateSimCardService', '$http', '$rootScope', '$stateParams', 'uteEndpoint', 'uteLocale', 'dtmService', 'dtmServiceConstants', '$translate', '$modal', function ($scope, $state, updateSimCardService, $http, $rootScope, $stateParams, uteEndpoint, uteLocale, dtmService, dtmServiceConstants, $translate, $modal) {

      $scope.ctnNumber = $stateParams.ctn.slice(0,3)+"-"+$stateParams.ctn.slice(3,6)+"-"+$stateParams.ctn.slice(6);
      $scope.newSimNumberInputDisabled = true;
      $scope.showErrorMessage = false;
      $scope.showSuccessMessage = false;
      $scope.oldSimNumber = ($stateParams.oldSimNumber) ? $stateParams.oldSimNumber : '';
      $scope.newSimNumber = ($stateParams.newSimNumber) ? $stateParams.newSimNumber : '';
      $scope.formProcessing = false;


      $scope.inputChanged = function (value, model, form) {

        form[model].$setValidity('pattern', false);
        form[model].$setValidity('validated', false);
        // var newValue = value.replace(/[^\dA-Z]/g, '').replace(/(.{5})/g, '$1 ').trim(); //Add Spaces after evry 5 digit
        // var patternCheck = /^\(?[0-9]{5}\)?[ ]?[0-9]{5}[ ]?[0-9]{5}$/.test(newValue);
        var newValue = value.replace(/[^\dA-Z]/g, '').trim();
        var patternCheck = /^[0-9]{15}$/.test(value);

        if(patternCheck) {
          form[model].$setValidity('pattern', true);
          form[model].$setValidity('validated', true);
        } else {
          form[model].$setValidity('pattern', false);
          form[model].$setValidity('validated', false);
        }
        if (model === 'oldSimNumber') {
          $scope.oldSimNumber = newValue;
        } else if (model === 'newSimNumber') {
          $scope.newSimNumber = newValue;
        }
      };

      function openModal(type) {
        $scope.modalInstance = $modal.open({
          templateUrl: 'modules/my-account/update-sim-card/modal-contents.html',
          scope: $scope,
          windowClass: (type === 'success') ? 'update-simcard-modal success' : 'update-simcard-modal error'
        });
      }

      // function removeSpacesandAddPrefixNumber(input) {
      //   return '89302' + input.replace(/\s/g, '');
      // }

      function addPrefixNumber(input) {
        return '89302' + input;
      }

      $scope.closeModal = function () {
        $scope.modalInstance.close();
        if ($scope.showSuccessMessage) {
          $scope.backToAccount();
        }
      }

      $scope.enableNewSimNumberInput = function () {
        $scope.newSimNumberInputDisabled = false;
      };

      $scope.dtmName = dtmServiceConstants.dtmRules.updateSimCard.name;

      $scope.updateSim = function () {
        if ($scope.updateSimForm.$valid) {

          $scope.formProcessing = true;

           $http.post(uteEndpoint('v1/wireless/validateSim'), {
             accountNumber: $stateParams.accountNumber,
             simCardNumber: addPrefixNumber($scope.newSimNumber),
             language:  uteLocale.language,
             ctn: $stateParams.ctn,
             oldSimNumber: addPrefixNumber($scope.oldSimNumber)
           }).success(function (data) {
             $scope.formProcessing = false;
            if (data.error && (data.error === '55057' || data.error === '55058' )) {
              // FUSS-1646: ChangeSimCard - NFDB Check
              $scope.showErrorMessage = true;
              $translate(['page.update-sim-card.error-message-invalid-sim-title', 'page.update-sim-card.error-message-invalid-sim-desc']).then(function (translatedValues) {
                $scope.modalHeading = translatedValues['page.update-sim-card.error-message-invalid-sim-title'];
                $scope.modalContent = translatedValues['page.update-sim-card.error-message-invalid-sim-desc'];
                openModal('error');
                var errorMessage = angular.isString(data.error) ? data.error + '-' + $scope.modalHeading + '-' + $scope.modalContent || dtmServiceConstants.dtmRules.updateSimCard.defaultServerError: dtmServiceConstants.dtmRules.updateSimCard.defaultServerError;
                dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateSimCard.name, [errorMessage], 'SS');

              });
            } else if(data && data.simValidation && data.simValidation === 'N') {
              //customer entered old sim doesn't match with existing sim in backend
              $scope.showErrorMessage = true;
              $translate(['page.update-sim-card.error-message-incorrect-old-sim-title', 'page.update-sim-card.error-message-incorrect-old-sim-desc']).then(function (translatedValues) {
                $scope.modalHeading = translatedValues['page.update-sim-card.error-message-incorrect-old-sim-title'];
                $scope.modalContent = translatedValues['page.update-sim-card.error-message-incorrect-old-sim-desc'];
                openModal('error');
                dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateSimCard.name, [translatedValues], 'SS');
              });
            } else {
              //If Everything is good goto Review state
              updateSimCardService.setNewSimNumber($scope.newSimNumber);
              $state.go("myAccount.updateSimCardReview", { 'accountNumber': $stateParams.accountNumber, 'ctn': $stateParams.ctn, 'oldSimNumber': $scope.oldSimNumber, 'newSimNumber':$scope.newSimNumber});
            }
          }).error(function (data) {
             $scope.formProcessing = false;
             $scope.showErrorMessage = true;
             $translate(['page.update-sim-card.error-message-general-system-error-title', 'page.update-sim-card.error-message-general-system-error-desc']).then(function (translatedValues) {
               $scope.modalHeading = translatedValues['page.update-sim-card.error-message-general-system-error-title'];
               $scope.modalContent = translatedValues['page.update-sim-card.error-message-general-system-error-desc'];
               openModal('error');
               dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateSimCard.name, [dtmServiceConstants.dtmRules.updateSimCard.defaultServerError], 'SS');
             });
          });

        }
      }

      $scope.submitReview = function () {
        $scope.formProcessing = true;
        $http.post(uteEndpoint('v1/wireless/updateEquipment'), {
          accountNumber: $stateParams.accountNumber,
          simCardNumber: addPrefixNumber($scope.newSimNumber),
          ctn: $stateParams.ctn
        }).success(function (data) {
          $scope.formProcessing = false;
          $scope.showErrorMessage = false;
          $scope.showSuccessMessage = true;
          $translate(['page.update-sim-card.success-message-title', 'page.update-sim-card.success-message-desc']).then(function (translatedValues) {
            $scope.modalHeading = translatedValues['page.update-sim-card.success-message-title'];
            $scope.modalContent = translatedValues['page.update-sim-card.success-message-desc'];
            openModal('success');
            dtmService.complete(dtmServiceConstants.dtmRules.updateSimCard.name);
          });
        }).error(function (data) {
          $scope.formProcessing = false;
          $scope.showErrorMessage = true;
          $translate(['page.update-sim-card.error-message-general-system-error-title', 'page.update-sim-card.error-message-general-system-error-desc']).then(function (translatedValues) {
            $scope.modalHeading = translatedValues['page.update-sim-card.error-message-general-system-error-title'];
            $scope.modalContent = translatedValues['page.update-sim-card.error-message-general-system-error-desc'];
            openModal('error');
            dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateSimCard.name, [dtmServiceConstants.dtmRules.updateSimCard.defaultServerError], 'SS');
          });
        });
      }

      $scope.cancel = function () {
        $state.go("myAccount.updateSimCard", { 'accountNumber': $stateParams.accountNumber, 'ctn': $stateParams.ctn });
      }

      $scope.backToAccount = function () {
        $state.go("myAccount.overview", { 'accountNumber': $stateParams.accountNumber });
      }

      $scope.simCheckRule = {
        newSimNumber: {
          type: 'number',
          pattern: '^[0-9]{20}$',
          required: true
        }
      };

    }]);
})();
